var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__content center login"},[(_vm.mobiflix_res_sub == '')?_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t("unsubscription"))+"\n          ")]):_c('h1',[_vm._v("\n            "+_vm._s(_vm.mobiflix_res_sub)+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55171cf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobiflix/Unsubscription.vue
// module id = 1660
// module chunks = 0